import ApiAgent, { handleError } from '@/common/agent/ApiAgent';
import { CampaignTimelineTypeEnum } from '@/campaign/main/model/CampaignApiTypes';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

interface StatusUserProfile {
  user_id: number;
  username: string;
  department_id: number;
  department_name: string;
  test_phone: string;
}

interface CampaignTimelineRes {
  timeline_no: number;
  timeline_type: CampaignTimelineTypeEnum;
  description: string;
  status_no?: string;
  created_at: string;
  created_by: StatusUserProfile;
}

export const queryKey = (id?: string) => ['campaignTimeline', id] as const;

export const useGetCampaignTimeline = (
  id?: string,
  options?: Omit<UseQueryOptions<CampaignTimelineRes[]>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery<CampaignTimelineRes[]>({
    queryKey: queryKey(id),
    queryFn: async () => {
      try {
        const response = await ApiAgent.get<CampaignTimelineRes[]>(`/campaign-management/timeline/${id}`);
        return response.data;
      } catch (error) {
        handleError(error);
        throw error;
      }
    },
    enabled: !!id,
    ...options,
  });
};
